import React from 'react';
import styled from 'styled-components';
import { useLocale, LOCALES } from '../LocaleContext';
import { techColors, neonGlow, terminalTextStyle } from '../styles/TechRetroEffects';

const ToggleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 18px;
  justify-content: center;
`;

const ToggleOption = styled.button.withConfig({
  shouldForwardProp: (prop) => prop !== 'active',
})`
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 7px 0;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  letter-spacing: 0.04em;
  line-height: 1;
  text-transform: uppercase;
  transition: color 0.2s ease, background-color 0.2s ease, box-shadow 0.2s ease;
  border: 1px solid ${({ active }) => (active ? techColors.borderGlow : techColors.borderMuted)};
  background: ${({ active }) => (active ? techColors.darkBgTertiary : 'transparent')};
  color: ${({ active }) => (active ? techColors.neonCyan : techColors.textSecondary)};
  ${({ active }) => active && neonGlow(techColors.neonCyan, 'subtle')}
  ${terminalTextStyle}

  &:hover {
    color: ${techColors.neonCyan};
    background: ${techColors.darkBgTertiary};
  }
`;

const LanguageToggle = () => {
  const { locale, setLocale, t } = useLocale();

  return (
    <ToggleRow role="group" aria-label={t('language.label')}>
      <ToggleOption
        type="button"
        active={locale === LOCALES.ru}
        onClick={() => setLocale(LOCALES.ru)}
        aria-label={t('language.ru')}
        aria-pressed={locale === LOCALES.ru}
        title={t('language.ru')}
      >
        RU
      </ToggleOption>
      <ToggleOption
        type="button"
        active={locale === LOCALES.en}
        onClick={() => setLocale(LOCALES.en)}
        aria-label={t('language.en')}
        aria-pressed={locale === LOCALES.en}
        title={t('language.en')}
      >
        EN
      </ToggleOption>
    </ToggleRow>
  );
};

export default LanguageToggle;
